import { checkoutStreetsMatch, splitCheckoutStreetAndNumber } from './checkoutAddressInput.js';

const text = value => String(value ?? '').replace(/\s+/g, ' ').trim();
// Keep the visible search and canonical geographic draft separate. A house
// number is appended only to that street; numbered street names stay intact.
export const googleCheckoutSearchQuery = ({ query = '', street = '', number = '' } = {}) => {
  const clean = text(query); const canonicalStreet = text(street); const house = text(number);
  if (!clean || !/^\d{1,6}[a-zA-Z]?(?:[-/]\w+)?$/.test(house)) return clean;
  const inline = splitCheckoutStreetAndNumber(clean, canonicalStreet);
  const typed = inline.number ? inline : splitCheckoutStreetAndNumber(clean);
  if (typed.number) return typed.number.toLowerCase() === house.toLowerCase() ? clean : '';
  return canonicalStreet && checkoutStreetsMatch(clean, canonicalStreet) ? `${clean}, ${house}` : clean;
};
